module.exports = __webpack_public_path__ + "dignose.06765323.png";